import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
@Component({
  selector: 'spot-ag-grid-filter-datepicker',
  templateUrl: './ag-grid-filter-datepicker.component.html',
  styleUrls: ['./ag-grid-filter-datepicker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgGridFilterDatepickerComponent implements OnDestroy {

  public date: string;

  private params: any;

  constructor(private cd: ChangeDetectorRef) { }

  agInit(params: any): void {
    this.params = params;
  }

  ngOnDestroy() {
    this.cd.detach();
  }

  getDate() {
    if (this.date) {
      return new Date(this.date);
    } else {
      return null;
    }
  }

  onModelChanged() {
    this.params.onDateChanged();
  }

  setDate(date: Date): void {
    if (date) {
      this.date = date.toISOString();
    } else {
      this.date = null;
    }

    this.cd.markForCheck();
  }

  clear() {
    this.date = null;
    this.onModelChanged();
  }

}
